import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import { Modal, FormControl, InputGroup } from 'react-bootstrap';
import { Tokenvalidate, settingvalidate } from '../../hooks/kycvalidation';
import { addsettinghook, addtokenhook } from '../../hooks/usebackend';

import proof from "../../images/proof.webp"
import toast from 'react-hot-toast';
import { TokenInfo } from '../../hooks/useContract';
import { isEmpty } from 'validator';
import { CURRENT_CHAIN_ID } from '../../hooks/useWeb3';

class Addtokenmodal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addtokenModal: true,
            // image: null,
            //imageFile: null,
            loadershow: false,
            imageurl:"",
            address: "",
            name: "",
            symbol: "",
            decimal: "",
            type: "",
            chainid: "",
            selectedValue: "",
            TokenselectedValue: "",
            preview: "",
            error: "",
            errors: {}
        };
    }


    // onImageChange = event => {
    //     if (event.target.files && event.target.files[0]) {
    //         let file = event.target.files[0];

    //         this.setState({
    //             imageFile: file,                // store file for upload
    //             image: URL.createObjectURL(file), // preview
    //             error: "",
    //         });
    //     }
    // };

    handleChange = (event) => {
        this.setState({ selectedValue: event.target.value });
    };
    handleChangeToken = (event) => {
        this.setState({ TokenselectedValue: event.target.value });
    };


    // handleImageUpload = async () => {
    //     const { imageFile } = this.state;
    //     console.log("imageFile_imageFile", imageFile);
    //     if (!imageFile) {
    //         toast.error("Please select an image first");
    //         return;
    //     }


    //     // Example upload (use your API logic)
    //     const formData = new FormData();
    //     formData.append("banner_image", imageFile);

    //     // Example API call
    //     // let resp = await axios.post("API_URL", formData);

    //     toast.success("Image upload triggered!");
    // };


    handleadd = async () => {
        console.log("handleadd");

        // let errors = {};

        // if (!/^\d+$/.test(this.state.decimal)) {
        //     errors.decimal = "Decimal must contain only numbers";
        // }

        // if (!/^\d+$/.test(this.state.chainid)) {
        //     errors.chainid = "Chain ID must contain only numbers";
        // }

        // if (Object.keys(errors).length > 0) {
        //     this.setState({ errors });
        //     return;
        // }
        let payload = {
            address: this.state.address,
            name: this.state.name,
            symbol: this.state.symbol,
            decimal: this.state.decimal,
            chainid: String(this.state.chainid),
            imageurl:this.state.imageurl,
            // image: this.state.imageFile,
            status: this.state.selectedValue,
            Currencytype: this.state.TokenselectedValue
        };
        console.log("payload_handleadd", payload);
        let validate = await Tokenvalidate(payload);
        console.log("validate_validate", validate);
        if (validate?.isValid) {
            let tokenresult = await addtokenhook(payload);
            console.log("ssetting result", tokenresult);
            this.props.onDismiss();
            this.props.getset();
            this.props.onreload()
        }
        else {
            this.setState({ "errors": validate.errors })
        }

    }

    handleTokenChange = async (value) => {
        let addressRegx = "^(0x)[0-9A-Fa-f]{40}$";
        let pattern = new RegExp(addressRegx);
        if(pattern.test(value)){
            console.log("handlechange---------");
            this.CheckToken(value);
            this.setState({ loadershow:true })
        }
        this.setState({ "address": value??"" })

    }

    CheckToken = async (token) => {
        try {
          let checkToken = await TokenInfo(token)
          console.log(checkToken, 'checkToken--------------')
          this.setState({ loadershow: true })

        //   if (!checkToken) {
        //    // SetisToken(false)
        //   //  SetshowText('Pasted address is not a token')
        //   }
        //   else if (!isEmpty(checkToken)) {
        //     console.log(checkToken, 'checkToken')
        //     // let importToken = { ...checkToken }
        //     // importToken['chainId'] = CURRENT_CHAIN_ID()
        //     // importToken['image'] = InfoIcon
        //     // SetisToken(true)
        //     this.setState({"name":checkToken?.name})
        //   }
        //   else {
        //     // SetisToken(false)
        //   }

        
          if(checkToken){
            this.setState({"name":checkToken?.name})
             this.setState({"symbol":checkToken?.symbol})
             this.setState({"decimal":checkToken?.decimal})
             this.setState({"totalSupply":checkToken?.totalSupply})
             this.setState({"chainid": CURRENT_CHAIN_ID()})
             this.setState({ loadershow: false })
          }

        } catch (err) {
          console.log(err, 'CheckToken__err')
        }
      }

    render() {


        const { addtokenModal, loadershow } = this.state


        return (



            <Modal className="wallet-modal" show={addtokenModal} centered size="md">
                <Modal.Header className='pt-3 header_odal_head'>
                    <h3 className="sec-head ">Add Token</h3>
                    <button type="button" class="close" onClick={() => this.props.onDismiss()}><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>

                </Modal.Header>
                <Modal.Body className="select-wallet modal_body pt-0 pb-0 px-0">

                    <div className="wallet-lists px-2">

                        <div className='mod_pad_space pt-0'>

                      {loadershow ? <div className='text-center'>
                        <span class="loaderz"></span>
                        <p className='themeclrtxt'>Token details will be displayed automatically. Please wait a moment.</p>
                        </div> : <></>}

                            <div className='row'>
                                <div className='col-12 col-md-12 px-1 mb-3'>



                                </div>
                                {/* <div className='col-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Setting Name</p>
                                    <div className="inputs input-groups">
                                        <InputGroup className="">
                                            <FormControl id="settingname" placeholder="Setting Name"
                                                aria-describedby="basic-addon2"
                                                value={this?.state?.settingname}
                                                onChange={(e) => {
                                                    this.setState({ "settingname": e?.target?.value })
                                                }}
                                            />

                                        </InputGroup>
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.settingname}</span>
                                    </div>
                                </div>

                                <div className='col-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Setting Value</p>      
                                    <div className="inputs input-groups">
                                        <InputGroup className="">
                                            <FormControl id="hardcap" placeholder="Setting Value"
                                                aria-describedby="basic-addon2"
                                                value={this?.state?.settingvalue}
                                                onChange={(e) => {
                                                    this.setState({ "settingvalue": e?.target?.value })
                                                }}
                                            />

                                        </InputGroup>
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.settingvalue}</span>
                                    </div>
                                </div> */}

                                {/* <div className='col-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Banner Image</p>
                                    <input type="file" className='listedimg' name="myImage" onChange={this.onImageChange} />
                                
                                </div>
                                
                                <div className='col-6 col-md-4 px-1 mb-3'>
                                    <img className='img-fluid' src={this.state.image} />
                                </div> */}


                                <div className='col-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Token Address</p>
                                    <div className="inputs input-groups">
                                        <InputGroup className="">
                                            <FormControl id="address" placeholder="Token address"
                                                aria-describedby="basic-addon2"
                                                value={this?.state?.address}
                                                onChange={(e) => {
                                                    this.handleTokenChange(e?.target?.value);
                                                    
                                                }}
                                            />

                                        </InputGroup>
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.address}</span>

                                    </div>
                                </div>
                                <div className='col-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Token Name</p>
                                    <div className="inputs input-groups">
                                        <InputGroup className="">
                                            <FormControl id="name" placeholder="Token name"
                                                aria-describedby="basic-addon2"
                                                value={this?.state?.name}
                                                onChange={(e) => {
                                                    this.setState({ "name": e?.target?.value })
                                                }}
                                            />

                                        </InputGroup>
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.name}</span>
                                    </div>
                                </div>
                                <div className='col-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Token Symbol </p>
                                    <div className="inputs input-groups">
                                        <InputGroup className="">
                                            <FormControl id="symbol" placeholder="Token symbol"
                                                aria-describedby="basic-addon2"
                                                value={this?.state?.symbol}
                                                onChange={(e) => {
                                                    this.setState({ "symbol": e?.target?.value })
                                                }}
                                            />

                                        </InputGroup>
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.symbol}</span>
                                    </div>
                                </div>

                                <div className='col-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Token Decimal </p>
                                    <div className="inputs input-groups">
                                        <InputGroup className="">
                                            <FormControl id="decimal" placeholder="Token decimal"
                                                aria-describedby="basic-addon2"
                                                value={this?.state?.decimal}
                                                onChange={(e) => {
                                                    this.setState({ "decimal": e?.target?.value })
                                                }}
                                            />

                                        </InputGroup>
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.decimal}</span>
                                    </div>
                                </div>

                                <div className='col-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Token Chainid </p>
                                    <div className="inputs input-groups">
                                        <InputGroup className="">
                                            <FormControl id="chainid" placeholder="Token chainid"
                                                aria-describedby="basic-addon2"
                                                value={this?.state?.chainid}
                                                onChange={(e) => {
                                                    this.setState({ "chainid": e?.target?.value })
                                                }}
                                            />

                                        </InputGroup>
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.chainid}</span>
                                    </div>
                                </div>

                                <div className='col-12 col-md-12 px-1 mb-3'>
                                    <label>Select Option: </label>

                                    <select className="form-control custm_sel"
                                        value={this?.state?.selectedValue}
                                        placeholder="Select Status"
                                        onChange={this.handleChange}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>

                                    </select>
                                    <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.status}</span>

                                </div>


                                <div className='col-12 col-md-12 px-1 mb-3'>
                                    <label>Select Option: </label>

                                    <select className="form-control custm_sel"
                                        value={this?.state?.TokenselectedValue}
                                        placeholder="Select Status"
                                        onChange={this.handleChangeToken}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="Token">Token</option>
                                        <option value="Coin">Coin</option>

                                    </select>
                                    <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.Currencytype}</span>

                                </div>

                                {/* <div className='col-12 col-md-12 px-1 mb-3'>
                                    <div>
                                        <p className='input_desc_sm'>Token Image</p> */}
                                {/* <div className='position-relative'>
                                        <input type="file" className='listedimg fileimg' name="myImage" onChange={this.onImageChange} />
                                        <button className="get-started-btn uploadedbtn" onClick={this.handleImageUpload}>
                                        Upload
                                       </button>
                                    </div> */}
                                {/* {this.state.image && (
                                            <img
                                                className='img-fluid imgset'
                                                src={this.state.image}
                                                alt="banner preview"
                                            />
                                        )} */}
                                {/* </div>
                                    {this.state.errors.error && <p className="text-danger f-12 d-block text-left mt-1">{this.state.errors.error}</p>}

                                </div> */}

                                <div className='col-12 col-md-12 px-1 mb-3'>
                                    <p className='input_desc_sm'>Token Image Url </p>
                                    <div className="inputs input-groups">
                                        <InputGroup className="">
                                            <FormControl id="imageurl" placeholder="Token imageurl"
                                                aria-describedby="basic-addon2"
                                                value={this?.state?.imageurl}
                                                onChange={(e) => {
                                                    this.setState({ "imageurl": e?.target?.value })
                                                }}
                                            />

                                        </InputGroup>
                                        <span className="text-danger f-12 d-block text-left">{this?.state?.errors?.imageurl}</span>
                                    </div>
                                </div>

                                <div className='col-12 col-md-12 px-1 text-center mt-5'>
                                    <button className="get-started-btn mt-2" onClick={this.handleadd}>
                                        Add
                                    </button>

                                </div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
            </Modal>



        )
    }

}


export default Addtokenmodal